import axios from 'axios';
import { buildDressDeclarationPlaceholders } from './dressDeclarationPlaceholders';
import { printTemplateDocument } from './printDocument';

export function formatDateForDeclarationPrint(dateString, getMonthName) {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = date.getDate();
    const month = getMonthName ? getMonthName(date.getMonth(), true) : date.toLocaleString('en', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  } catch {
    return dateString;
  }
}

export async function printDressDeclaration({
  salonId,
  templateId,
  dress,
  t,
  formatPrice,
  getMonthName,
  salonSlug
}) {
  const token = localStorage.getItem('token');
  const response = await axios.get(`/api/salons/${salonId}/declarations/${templateId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  const declaration = response.data.declaration || response.data;
  const content = declaration.declaration_content;

  if (!content) {
    throw new Error(t('messages.error.declarationTemplateNoContent', 'Declaration template has no content'));
  }

  const formatDate = (dateString) => formatDateForDeclarationPrint(dateString, getMonthName);
  const placeholderMap = await buildDressDeclarationPlaceholders(dress, { t, formatPrice, formatDate, salonSlug });

  printTemplateDocument({
    title: declaration.title || t('dresses.printDeclaration', 'Print declaration'),
    templateContent: content,
    placeholderMap,
    contentClass: 'declaration-content',
    pageWidthCm: Number(declaration.page_width) || 7,
    pageHeightCm: Number(declaration.page_height) || 5
  });
}
